import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Photo } from 'src/app/model/installation/photos.model';
import { InstallationsService } from 'src/app/services/http/installations/installations.service';

@Component({
  selector: 'app-photo',
  templateUrl: './photo.component.html',
  styleUrls: ['./photo.component.scss']
})
export class PhotoComponent implements OnInit {

  @Input()
  photo!: Photo;
  public imageSrc!: SafeResourceUrl;
  private fileExtension!: string;
  public isImage: boolean = false;
  public dataType: string = 'unknown';

  constructor( private sanitizer: DomSanitizer, private service : InstallationsService ) { }

  ngOnInit(): void {
    if(this.photo) {
      this.updateDatatype();
      this.setImage();
    }
  
  }

  
async setImage( )  {

  let image = await this.service.getPhoto(this.photo).toPromise();
  this.imageSrc = this.sanitizer.bypassSecurityTrustResourceUrl('data:'+  this.dataType +';base64, '+image);
  console.log(this.imageSrc);
}

  private updateDatatype(){
    if (this.photo) {
      this.fileExtension = this.photo.filename.split('.')[1];
    }

    if ( this.fileExtension == 'jpg' || this.fileExtension == 'jpeg' ) {
      this.dataType = 'image/jpeg';
    }else if( this.fileExtension == 'png' ){
      this.dataType = 'image/png';
    }
  }
}
